<template lang="pug">
.card.mb-0
  .card-body
    .row
      .col
        b-form-group(:label="$t('ui.provider')").mb-0
          b-form-select(
            ref="provider"
            :dirty="$v.provider.$dirty"
            :error="$v.provider.$error"
            v-model.trim.lazy="$v.provider.$model"
            :disabled="loading"
            size="sm"
            @change="getFreeRoundGameList($event)"
          )
            option(value="" disabled selected) {{ $t("message.select_option") }}
            option(value="EPW") EPICWIN
            option(value="MGH") MEGAH5
            option(value="GSC-PP-S") PRAGMATIC
          ValidateResult(:value="$v.provider" :name="$t('ui.provider')")
    template(v-if="['EPW','MGH'].includes(provider)")
      .row
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.game')").mb-0
            b-form-select(
              ref="game_code"
              size="sm"
              :dirty="$v.game_code.$dirty"
              :error="$v.game_code.$error"
              v-model.trim.lazy="$v.game_code.$model"
              :disabled="loading"
              @change="getGameInfo($event)"
            )
              option(value="" disabled selected) {{ $t("message.select_option") }}
              option(v-for="opt in gameCodeOpt" :value="opt.GameCode") {{ opt.GameName }} ({{opt.GameCode}}) - {{opt.TotalLine}} {{ $t("ui.lines") }}
            ValidateResult(:value="$v.game_code" :name="$t('ui.game')")
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.bet_value')").mb-0
            b-form-select(
              ref="bet_value"
              size="sm"
              :dirty="$v.bet_value.$dirty"
              :error="$v.bet_value.$error"
              v-model.trim.lazy="$v.bet_value.$model"
              :disabled="loading",
            )
              option(value="" disabled selected) {{ $t("message.select_option") }}
              option(v-for="opt in betValueOpt" :value="opt") {{ opt }}
            ValidateResult(:value="$v.bet_value" :name="$t('ui.bet_value')")
      .row
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.line_bet')").mb-0
            b-form-select(
              ref="line_bet"
              size="sm"
              :dirty="$v.line_bet.$dirty"
              :error="$v.line_bet.$error"
              v-model.trim.lazy="$v.line_bet.$model"
              :disabled="loading"

            )
              option(value="" disabled selected) {{ $t("message.select_option") }}
              option(v-for="opt in lineBetOpt" :value="opt") {{ opt }}
            ValidateResult(:value="$v.line_bet" :name="$t('ui.line_bet')")
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.total_round')").mb-0
            DebounceInput(
              size="sm"
              ref="total_round"
              required
              type="text"
              :dirty="$v.total_round.$dirty"
              :error="$v.total_round.$error"
              v-model.trim.lazy="$v.total_round.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.total_round" :name="$t('ui.total_round')")
      .row
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.max_win_amount')").mb-0
            DebounceInput(
              size="sm"
              ref="max_win_amount"
              required
              type="text"
              :dirty="$v.max_win_amount.$dirty"
              :error="$v.max_win_amount.$error"
              v-model.trim.lazy="$v.max_win_amount.$model"
              :disabled="loading"
            )
            span.small.text-info {{ $t("message.issue_free_spin_rule") }}
            ValidateResult(:value="$v.max_win_amount" :name="$t('ui.max_win_amount')")
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.expiry_interval_days')").mb-0
            DebounceInput(
              size="sm"
              ref="expiry_interval"
              required
              type="text"
              :dirty="$v.expiry_interval.$dirty"
              :error="$v.expiry_interval.$error"
              v-model.trim.lazy="$v.expiry_interval.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.expiry_interval" :name="$t('ui.expiry_interval_days')")
    template(v-if="['GSC-PP-S'].includes(provider)")
      .row
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.game')").mb-0
            b-form-select(
              ref="game_code"
              size="sm"
              :dirty="$v.game_code.$dirty"
              :error="$v.game_code.$error"
              v-model.trim.lazy="$v.game_code.$model"
              :disabled="loading"
              @change="getGameInfoPPS($event)"
            )
              option(value="" disabled selected) {{ $t("message.select_option") }}
              option(v-for="opt in gameCodeOpt" :value="getPPSGameOpt(opt)") {{ opt.game_name }} ({{opt.game_code}})
            ValidateResult(:value="$v.game_code" :name="$t('ui.game')")
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.line_bet')").mb-0
            b-form-select(
              ref="line_bet"
              size="sm"
              :dirty="$v.line_bet.$dirty"
              :error="$v.line_bet.$error"
              v-model.trim.lazy="$v.line_bet.$model"
              :disabled="loading"

            )
              option(value="" disabled selected) {{ $t("message.select_option") }}
              option(v-for="opt in lineBetOpt" :value="opt") {{ opt }}
            ValidateResult(:value="$v.line_bet" :name="$t('ui.line_bet')")
      .row
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.total_round')").mb-0
            DebounceInput(
              size="sm"
              ref="total_round"
              required
              type="text"
              :dirty="$v.total_round.$dirty"
              :error="$v.total_round.$error"
              v-model.trim.lazy="$v.total_round.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.total_round" :name="$t('ui.total_round')")
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.expiry_interval_days')").mb-0
            DebounceInput(
              size="sm"
              ref="expiry_interval"
              required
              type="text"
              :dirty="$v.expiry_interval.$dirty"
              :error="$v.expiry_interval.$error"
              v-model.trim.lazy="$v.expiry_interval.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.expiry_interval" :name="$t('ui.expiry_interval_days')")
    .row
      .col
        b-form-group
          label {{ $t('ui.member_list') }}
          i.fa.fa-info-circle.text-info.ml-2(:title="$t('message.tooltips_promo_member_custom')")
          b-form-textarea.col-12(
            ref="member_list"
            size="sm"
            required
            :dirty="$v.member_list.$dirty"
            :error="$v.member_list.$error"
            v-model.trim.lazy="$v.member_list.$model"
            rows="10"
            max-rows="10"
            trim=true
            :disabled="loading"
            @paste="handlePaste"
          )
          ValidateResult(:value="$v.member_list" :name="$t('ui.member_list')")
    div.mt-4(v-if="isEditAccess")
      SubmitButton.float-right(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" @click="submit")

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import { required, requiredIf, helpers, integer, decimal, maxValue } from "vuelidate/lib/validators";
import ValidateResult from "@/library/ValidateResult";
const validUrl = helpers.regex(
  "validUrl",
  /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z]{2,}(?:[/?#][^\s]*)?$/i
);

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      provider: "",
      game_code: "",
      bet_value: "",
      line_bet: "",
      total_round: "",
      max_win_amount: "",
      expiry_interval: "",
      total_lines: "",
      gameList: [],
      betValueOpt: [],
      gameCodeOpt: [],
      lineBetOpt: [],
      member_list: "",
      isUat: config.isUat,
    };
  },
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("issuefreespin");
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    },
  },
  validations() {
    return {
      provider: {
        required
      },
      game_code: {
        required
      },
      bet_value: {
        required: requiredIf(function () {
          return ['EPW','MGH'].includes(this.provider)
        }),
      },
      line_bet: {
        required
      },
      total_round: {
        required,
        integer
      },
      member_list: {
        required
      },
      max_win_amount: {
        required: requiredIf(function () {
          return ['EPW','MGH'].includes(this.provider)
        }),
        decimal,
        maxValue(value) {
          return maxValue((this.total_lines * this.line_bet * this.bet_value * 5000).toFixed(2))(value)
        }
      },
      expiry_interval: {
        required,
        integer
      }
    }
  },
  mounted: function() {
  },
  methods: {
    setTab(tab) {
      this.activeTab = tab;
    },
    refresh() {
      this.reset();
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.provider= "";
      this.game_code = "";
      this.bet_value = "";
      this.line_bet = "";
      this.total_round = "";
      this.max_win_amount = "";
      this.expiry_interval = "";
      this.member_list = "";
      this.gameList = [];
      this.betValueOpt = [];
      this.gameCodeOpt = [];
      this.lineBetOpt = [];
      this.$v.$reset();
    },
    getPPSGameOpt: function(obj) {
      return obj.game_code + '-' + obj.product_code;
    },
    handlePaste(event) {
      event.preventDefault(); // Prevent the default paste action

      // Get the pasted data from the clipboard
      let pastedData = event.clipboardData.getData('Text');

      // Remove newline characters from the pasted data
      pastedData = pastedData.replace(/\n/g, ' ');

      // Split the pasted data into an array by whitespace characters
      let dataArray = pastedData.split(' ');

      // Remove the first row if it is "ID"
      if (dataArray[0].trim() === 'ID') {
        dataArray.shift();
      }

      // Filter out any empty strings in the array
      dataArray = dataArray.map(item => item.trim()).filter(item => item !== '');

      // Join the array into a comma-separated string
      const commaSeparatedData = dataArray.join(', ');

      // Set the text area content to the comma-separated string
      this.member_list = commaSeparatedData;
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const result = this.member_list.split(',').map(item => ({
        account_id: item.trim()
      }));

      this.proceed(result);
    },
    proceed(csv) {
      let url = config.bulkIssueFreeSpinUrl()

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        provider_code: this.provider,
        operator_id: this.operatorID,
        member_list: csv,
        line_bet: this.line_bet,
        total_round: this.total_round,
        expiry_interval: this.expiry_interval
      };

      if (['EPW','MGH'].includes(this.provider)) {
        json.game_code = this.game_code;
        json.bet_value = this.bet_value;
        json.max_win_amount = this.max_win_amount;
      } else if (['GSC-PP-S'].includes(this.provider)) {
        var gamecode = this.game_code.split('-')[0].trim();
        var productcode = this.game_code.split('-')[1].trim();
        json.game_code = gamecode;
        json.product_code = productcode;
      }

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.combine.issue_free_spin"), this.$t("message.success"), "success");
                this.reset();
              } else {
                this.$helpers.showDialog(this.$t("ui.combine.issue_free_spin"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui." + tag), this.$t("error." + status), "error");
    },
    clearValue() {
      this.game_code = "";
      this.bet_value = "";
      this.line_bet = "";
      this.total_round = "";
      this.max_win_amount = "";
      this.expiry_interval = "";
      this.member_list = "";
      this.gameList = [];
      this.betValueOpt = [];
      this.gameCodeOpt = [];
      this.lineBetOpt = [];
      this.$v.$reset();
    },
    getGameInfo: function(code) {
      if (code && code != '') {
        this.bet_value = "";
        this.line_bet = "";
        this.total_lines = "";
        this.max_win_amount = "";
        this.betValueOpt = this.gameList.filter(item => { return item.GameCode == code })[0]['AvailableBetValue'];
        this.lineBetOpt = this.gameList.filter(item => { return item.GameCode == code })[0]['AvailableLineBet'][0]['LineBets'];
        this.total_lines = this.gameList.filter(item => { return item.GameCode == code })[0]['TotalLine'];
      }
    },
    getGameInfoPPS: function(code) {
      if (code && code != '') {
        this.line_bet = "";
        var gamecode = code.split('-')[0]
        this.getFreeRoundGameLineBetPPS(gamecode);
      }
    },
    getFreeRoundGameLineBetPPS: function(code) {
      let url = config.ppsGetFreeRoundGameLineBetUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        game_code: code
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                var betScalesList = response.data.dt.filter(item => { return item.gameID == code })[0]['betScaleList']; //this is array
                var currency = (this.isUat == 'true' ? 'IDR' : this.getCurrencyCode);
                var betPerLineScales = betScalesList.filter(item => { return item.currency == currency})[0]['betPerLineScales']; //this is array
                this.lineBetOpt = betPerLineScales;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getFreeRoundGameList: function() {
      if (this.provider == "")
        return;

      this.clearValue();

      let url = "";

      if (this.provider == 'EPW')
        url = config.epicWinGetFreeRoundGameListUrl();
      else if (this.provider == 'MGH')
        url = config.megah5GetFreeRoundGameListUrl();
      else if (this.provider == 'GSC-PP-S')
        url = config.ppsGetFreeRoundGameListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.gameList = response.data.dt;
                this.gameCodeOpt = this.gameList != null ? this.gameList : [];
                this.game_code = "";
                this.bet_value = "";
                this.line_bet = "";
                this.max_win_amount = "";
                this.expiry_interval = "";
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
  }
};
</script>
<style lang="scss" scoped>
</style>